// shared with AppUserPage column builder
import {Box, Typography as T, useTheme} from '@mui/material';
import React from 'react';
import {mfaColor, privColor} from 'src/components/common/Tables/DefaultGrid/dataGridUtilities';
import {
  maxEmailLength,
  maxNameLength,
  maxOtherLength, mfaStatusDisplayString,
  TruncatableString,
} from 'src/components/common/Tables/Utilities';
import {MultipleValuesInPopup} from 'src/components/common/Tables/Utilities/Recipients';
import {UserNameLink} from 'src/components/common/Tables/Utilities/tableCells/styles';
import {calculatedMfaStatus} from 'src/services/shared/sharedTransforms';
import {IUser} from 'src/types/User';

import {truncatedString} from "src/utils/string";
import {dashboardRoute, isShowingApp, searchParamKeys} from "../../../../routes";
import {DefaultLink} from "../../DefaultLink";
import {GridColumnHeaderParams, GridRenderCellParams} from "@mui/x-data-grid";

export const renderUserName = (
  // params: any,
  name: string,
  pubId: string,
  route: string,
  hasUserUrl?: boolean,
) => {
  return (
    <TruncatableString
      maxLength={maxNameLength}
      truncateFunction={truncatedString}
      // value={params.row.name}
      value={name}
      displayComponent={(truncatedValue: any) =>
        hasUserUrl ? /// row.user.hasUserUrl ?
          (
            // <UserNameLink to={`${route}/${params.row.pubId}`}>
            <UserNameLink to={`${route}/${pubId}`}>
              {truncatedValue}
            </UserNameLink>
          ) : (
            <span>{truncatedValue}</span>
          )
      }
    />
  );
};

export const renderAppName = (
  name: string,
  pubId: string
) => {
  return (
        pubId ?
          (
            <DefaultLink
              to={`${dashboardRoute}?${searchParamKeys.discovery}=${isShowingApp}&${searchParamKeys.appId}=${pubId}`}
              style={{textDecoration: 'none'}}
            >
              <T variant='body2' >
                {name}
              </T>
            </DefaultLink>
          ) : (
            <span>{name}</span>
          )
  );
};

export const renderEmail = (params: any) => {
  // console.log('renderEmail', {params});
  return (
    <TruncatableString
      maxLength={maxEmailLength}
      truncateFunction={truncatedString}
      value={params.row.email}
      displayComponent={
        (truncatedValue: any) =>
          <span>{truncatedValue}</span>
      }
    />
  );
};

export const renderDLP = (params: any) => {
  return (
    <TruncatableString
      maxLength={maxOtherLength}
      truncateFunction={truncatedString}
      value={params.row.policy}
      displayComponent={
        (truncatedValue: any) =>
          <span>{truncatedValue}</span>
      }
    />
  );
};

export const renderSharedItem = (params: any) => {
  return (
    <TruncatableString
      maxLength={maxOtherLength}
      truncateFunction={truncatedString}
      value={params.row.sharedItem}
      displayComponent={
        (truncatedValue: any) =>
          <span>{truncatedValue}</span>
      }
    />
  );
};

export const renderSharedTo = (params: any) => {
  // console.log('renderSharedTo', {params});
  // make an array of emailAddresses from the sharedTo array field
  const emailArray = params.row.sharedTo.map(
    (share: { email: any; }) => share.email
  )
  // console.log('renderSharedTo', {emailArray});
  return (
    <MultipleValuesInPopup valueArray={emailArray} />
  );
};

export const renderLicences = (params: any) => {
  // console.log('renderLicences', {params});
  return (
    <MultipleValuesInPopup
      valueArray={params.row.userLicenceNames}
      valueLabel={'licences'}
    />
  );
};

const PrivilegeRender = ({privilegeLevel}: {privilegeLevel: string}) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      sx={{
        color: privColor(privilegeLevel, theme),
      }}
    >
      {privilegeLevel}
    </Box>);
};

export const renderPrivilege = (params: any) => {
  return (
    <PrivilegeRender privilegeLevel={params.value} />
  );
};

const MfaRender = ({user}: {user: IUser}) => {
  const theme = useTheme();
  const mfaStatus = calculatedMfaStatus(user)
  return (
    <Box
      component="span"
      sx={{
        color: mfaColor(mfaStatus, theme),
      }}
    >
      {mfaStatusDisplayString(mfaStatus)}
    </Box>);
};

export const renderMfa = (params: any) => {
  return (
    <MfaRender user={params.row} />
  );
};

// Provides a column definition with a test id on its header
export const labelledColumn = ({title, renderCell, valueGetter}:
   {
     title: string,
     renderCell?: (row: GridRenderCellParams) => any,
     valueGetter: (value: any, row: any) => string
   }
) => {
  return {
    renderHeader: (params: GridColumnHeaderParams) =>
      <span data-testid={`grid-heading-${title}`}>{title}</span>,
    valueGetter,
    renderCell,
  }
}
